import 'react-native-gesture-handler';
import * as React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import {MaterialCommunityIcons} from '@expo/vector-icons'
import  TabIcon from './TabIcon';
import { COLORS, icons } from "../constants"

//Screens
import Home from './home'
import Recents from './recents'
import Profile from './profile'
import Search from './search'


import { createMaterialBottomTabNavigator } from '@react-navigation/material-bottom-tabs';

const Tab = createMaterialBottomTabNavigator();

const Tabs = (props) => {
  return (
   
    <Tab.Navigator
    tabBarOptions={{
        showLabel: false,
        style: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            elevation: 0,
            backgroundColor: '#fff',
            borderTopColor: "transparent",
            height: 100
        }
    }}
>
    <Tab.Screen
        name="Home"
        component={Home}
        options={{
            tabBarIcon: ({ focused }) => (
                <TabIcon
                    focused={focused}
                    icon={icons.home}
                />
            )
        }}
    />
    <Tab.Screen
        name="Play"
        component={Recents}
        options={{
            tabBarIcon: ({ focused }) => (
                <TabIcon
                    focused={focused}
                    icon={icons.play_button}
                />
            )
        }}
    />
    <Tab.Screen
        name="Search"
        component={Search}
        options={{
            tabBarIcon: ({ focused }) => (
                <TabIcon
                    focused={focused}
                    icon={icons.search}
                />
            )
        }}
    />
    <Tab.Screen
        name="Profile"
        component={Profile}
        options={{
            tabBarIcon: ({ focused }) => (
                <TabIcon
                    focused={focused}
                    icon={icons.profile}
                />
            )
        }}
    />
      </Tab.Navigator>
    
  );
}


export default Tabs;